import manage from "@/pages/order/dashboard";
import list from "@/pages/order/list";
import add from "@/pages/order/add";
import edit from "@/pages/order/edit";
import view from "@/pages/order/view";
import shopCart from "@/pages/shop/shopCart";
import sendOrderList from "../pages/order/sendOrderList";
const routes = [
  {
    path: "/customerOrder/Manage",
    component: manage,
    meta: {requiredAuth: true},
  },
  {
    path: "/order/list",
    component: list,
    meta: {requiredAuth: true},
  },
  {
    path: "/order/add/:customer_id?/:mission_item_id?",
    component: add,
    meta: {requiredAuth: true},
  },
  {
    path: "/order/Edit/:id",
    component: edit,
    meta: {requiredAuth: true},
  },
  {
    path: "/order/view/:id",
    component: view,
    meta: {requiredAuth: true},
  },
  {
    path: "/ShopCart",
    component: shopCart,
    meta: {requiredAuth: true},
  },
  {
    path: "/SendOrder/List",
    component: sendOrderList,
    meta: {requiredAuth: true},
  }
]

export default routes;